module.exports = __webpack_public_path__ + "img/BrightLightGlobe.7156f947.png";